import React, { useState, useEffect } from 'react';
import { CompanyModalProps } from '../../types/swipeable';

export const CompanyModal: React.FC<CompanyModalProps> = ({ site, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // マウント時にアニメーション開始
    setIsVisible(true);
  }, []);

  // モーダルが開いている時に背景のスクロールを無効にする
  useEffect(() => {
    if (isVisible) {
      // 現在のスクロール位置を保存
      const scrollY = window.scrollY;
      
      // bodyを固定してスクロール位置を保持
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      
      // 全てのスクロールイベントを無効にする
      const preventScroll = (e: Event) => {
        e.preventDefault();
        e.stopPropagation();
        return false;
      };
      
      // イベントリスナーを追加（capture phaseで）
      document.addEventListener('wheel', preventScroll, { passive: false, capture: true });
      document.addEventListener('touchmove', preventScroll, { passive: false, capture: true });
      document.addEventListener('scroll', preventScroll, { passive: false, capture: true });
      
      return () => {
        // イベントリスナーを削除
        document.removeEventListener('wheel', preventScroll, { capture: true });
        document.removeEventListener('touchmove', preventScroll, { capture: true });
        document.removeEventListener('scroll', preventScroll, { capture: true });
        
        // bodyのスタイルを復元
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        
        // スクロール位置を復元
        window.scrollTo(0, scrollY);
      };
    }
  }, [isVisible]);

  const handleClose = () => {
    setIsVisible(false);
    // アニメーション完了後にモーダルを閉じる
    setTimeout(onClose, 300);
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handleWebsiteClick = () => {
    const website = site?.settings?.companyInfo?.website;
    if (website) {
      window.open(website, '_blank');
    }
  };

  return (
    <div 
      className={`company-modal-backdrop ${isVisible ? 'visible' : ''}`}
      onClick={handleBackdropClick}
    >
      <div className={`company-modal-content ${isVisible ? 'visible' : ''}`}>
        <div className="company-modal-header">
          <h3>会社概要</h3>
          <button className="close-button" onClick={handleClose}>
            ✕
          </button>
        </div>
        
        <div className="company-modal-body">
          {site?.settings?.companyInfo?.website && (
            <div className="company-info-item">
              <div 
                className="company-website"
                onClick={handleWebsiteClick}
              >
                {site.settings.companyInfo.website}
              </div>
            </div>
          )}
          
          {site?.settings?.companyInfo?.companyName && (
            <div className="company-info-item company-name">
              <div className="company-name">{site.settings.companyInfo.companyName}</div>
            </div>
          )}
          
          {site?.settings?.companyInfo?.address && (
            <div className="company-info-item company-address">
              <div className="company-address">
                {site.settings.companyInfo.address}
              </div>
            </div>
          )}
          
          {site?.settings?.companyInfo?.description && (
            <div className="company-info-item">
              <div className="company-description">
                {site.settings.companyInfo.description}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
